//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TransientObject.js";
import "../no/Expression.js";
let d=[[[0,"AlternateSolution",0,0],[1,"ArcLength",0,"Expression",0],[0,"ArcLengthType",1,0],[0,"ConstraintType",1,0],[0,"Geometry",1,"DisplayableObject",0]],[[["length"],"SetArcLength",{},1,0],[["solution"],"SetAlternateSolution",{},1,0],[[],"Dispose",{},0,0]],[]];
SPLM.DatumConstraint = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.DatumConstraint";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.DatumConstraint.CurveOption = Object.freeze({
    "Distance" : "Distance", "Percent" : "Percent"});

SPLM.DatumConstraint.Solution = Object.freeze({
    "Undefined" : "Undefined", "Tangent" : "Tangent", "Normal" : "Normal", "Binormal" : "Binormal", "OppositeTangent" : "OppositeTangent", "OppositeNormal" : "OppositeNormal", "OppositeBinormal" : "OppositeBinormal", "Project" : "Project"});

SPLM.DatumConstraint.Type = Object.freeze({
    "Undefined" : "Undefined", "Coincident" : "Coincident", "Parallel" : "Parallel", "Perpendicular" : "Perpendicular", "Center" : "Center", "Tangent" : "Tangent", "Distance" : "Distance", "Angle" : "Angle", "Frenet" : "Frenet"});

export default SPLM;